<svelte:head>
    <script  src="../dist/echarts.min.js"
			  crossorigin="anonymous"
			  on:load={echartsLoaded}
			  defer>
  </script>  
</svelte:head>

<script>

//
//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
//     import defaultExport from "module-name";
//     import * as name from "module-name";
//     import { export1 } from "module-name";
//     import { export1 , export2 as alias2 , [...] } from "module-name";
//     import "module-name";
//     var promise = import("module-name");
//

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';
import { cubejsclient_service  , cubejsclient_service_context_key   } from '../_services/cubejsClient.js';

//import MySvelteChart			from './Page_0001_Chart.svelte';   

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------

let display_chart = false;


let xAxis_headers = [];

   var is_dataLoaded = false;
	onMount(async () => {
		if ($loggedIn) {
			is_dataLoaded = true;
		}
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_echartsLoaded 
  		       && is_dataLoaded
  		   )
  	  {
			is_dependenciesLoaded = true;
  		}
  }


  var is_echartsLoaded = false;
  function echartsLoaded() {
		// The external javascript library is ready.
		is_echartsLoaded = true;
		dependenciesLoaded();
  }
  
// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------


//$: run = is_dependenciesLoaded && handleClickGetResult()  // <<-- should be hanlded in the onMount() ??

$: display_chart = is_dependenciesLoaded;

</script>


<style>

	.applet {
		width: inherit;
		height: inherit;
	}

	.chart_wrapper {
		width: inherit;
		margin: 0 auto;
		padding: 0px;
		
		display: flex; /* or inline-flex */
		/* flex-wrap: wrap; */
		flex-flow: row wrap;
		justify-content: flex-start; /* flex-start | space-around | space-evenly*/
	}

	.chart {
		width: inherit;
		height:450px;
	}
 
</style>


<div class="applet">
	<div>
		<p>My Finances :: Financial Statements</p>
		<p>App Chart_0002</p>
	</div>
	

	{#if $loggedIn}


		{#if display_chart}
		<div class="chartWrapper">
			<div id="chart" class="chart"></div>
			<script type="text/javascript" >
		
		         var query_environment = 'dev';
		         var query_id = 'bPMenuaJcJsyqoqT';
		         var query_limit = '1000';
		
					// Call an authentication microservice to handle the authentication.
					var response =  fetch("https://analytics.artificiality.be/"+query_environment+"/cubejs/"+query_id+"/result?autoLimit="+query_limit+"",
					{
					    method: 'GET',
					    credentials: 'include',    // omit | include | same-origin
					    headers: {
					        'api_id': 'CUBEJS_API_KEY',
					        'client_id': 'CUBEJS_CLIENT_ID',
					        'client_secret': 'CUBEJS_CLIENT_SECRET',
					        'client_session': CUBEJS_CLIENT_SESSION,
					        'Content-Type': 'application/vnd.artificiality.cubejs.query-v1+json',
					        'Accept':       'application/vnd.artificiality.cubejs.queryresult-v1+json',
		   			    },
					    body: JSON.stringify( ),
					})
					.then((response) => response.json() )
					.then((response) => {
		
								if (response.data) {
		
		        							if ( response.data.length > 0 ) {
				console.log('function FenIBlGuuHZeT4Nj()');
		console.log( Object.keys( response.data[0] ) ) ;
		
		
		        // based on prepared DOM, initialize echarts instance
				        var myChart = echarts.init(document.getElementById('chart'));
				        
				        // specify chart configuration item and data
				        var option = {
				            title: {
				                text: 'Financial Statements Evolution - Weekly'
				            },
				            tooltip: {},
				            legend: {
				                data:['Financialstatements count']
				            },
				            xAxis: {
				//              data: ["shirt","cardigan","chiffon shirt","pants","heels","socks"]
				//					 data: Object.keys( response.data[0] )
									 data: response.data.map(datapoint => {
																		    return datapoint['MyfinancesFinancialstatements.financialstatementStatementDt'].split("T")[0];
																		})
				            },
				            yAxis: {},
				            series: [{
				                name: 'total',
				                type: 'bar',
		                      stack: 'one',
		        //               data: [5, 20, 36, 10, 10, 20]
				                data: response.data.map(datapoint => {
																		    return datapoint['MyfinancesFinancialstatements.total'];
																		})
				 
				            },{
				                name: 'count',
				                type: 'bar',
		                      stack: 'two',
				 //               data: [5, 20, 36, 10, 10, 20]
				                data: response.data.map(datapoint => {
																		    return datapoint['MyfinancesFinancialstatements.count'];
																		})
				 
				            },]
				        };
		
		
			           // use configuration item and data specified to show chart
				        myChart.setOption(option);	
		
		
										}
							 
								} else {
									// invoke callback
									console.log(/*exception obj*/ {type : 'exception', 
																				msg: 'something went wrong' } );
								}
		
					  })
					  .catch((err) => {
									console.log(/*exception obj*/ {type : 'exception', 
																				msg: '[catch] something went wrong: '+ err.message } );
					})
					;
		
			</script>
		</div>
	
		{:else}
		<div>
				<p>Loading data and scripts and what not...</p>
		</div>
	{/if}


	{:else}
	<div>
		<p>Please log in...</p>
	</div>
	{/if}


</div>
